import { useCallback } from 'react';

import { useAudioTrigger } from '@pp/core/src/controllers/audioController/hooks';

import { Bets } from '../../../config/bets';
import { GameCommunicationCashOutSender } from '../../../controllers/gameCommunication/senders/GameCommunicationCashOutSender';
import { useGameDispatch } from '../../../store/GameStore';
import { highflyerStateActions } from '../../../store/slices/highflyerState/slice';

const sender = new GameCommunicationCashOutSender();

export const useOnCashoutCallBackConnected = (): ((betCode: Bets) => void) => {
  const dispatch = useGameDispatch();
  const audioTrigger = useAudioTrigger();

  return useCallback(
    (betCode: Bets): void => {
      audioTrigger.play({ name: 'chipClick' });
      dispatch(highflyerStateActions.setLocalCashedMul(betCode));
      sender.dispatch({
        betCode: betCode,
      });
    },
    [audioTrigger, dispatch]
  );
};
